import { render, staticRenderFns } from "./v-ship-select.vue?vue&type=template&id=d80d068a&scoped=true&"
import script from "./v-ship-select.vue?vue&type=script&lang=js&"
export * from "./v-ship-select.vue?vue&type=script&lang=js&"
import style0 from "./v-ship-select.vue?vue&type=style&index=0&id=d80d068a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d068a",
  null
  
)

export default component.exports